/*******************************************************************************
 * @license (c)Copyright Since 2018, SOFTBANK Corp. All rights reserved.
 *
 *    機能概要  : 商品選択画面＆内容確認画面の初期処理
 *    システム  : iTunesCDD
 ******************************************************************************/
'use strict';

$(function () {

    // pageNameの初期設定 ＞ 通常
    commonGA.setSessionStorage('pageName', commonGA.ITEM_SELECT_NORMAL);

    // サポート端末のチェック
    utility.deviceSupportCheck();
    // UAチェックファンクション呼び出し
    utility.userAgentChk();
    // tokenをSessionStore情報に格納する
    utility.setTokenToSessionStore();
    // Topボタンの設定
    utility.topBtnController();

    // 画面初期処理
    // 共通の商品選択の画面表示処理呼び出し
    var initCommand = utility.getEnviromentInfo(initCommandList, environment_id);
    if (initCommand) {
        setTimeout(initCommand, 0);
    }
});

/************************************/
/******* クリックイベント処理 *******/
/************************************/
var clickEvent = {
    // 購入内容確認ボタン（商品選択画面）
    selectProuctEvent: function () {
        $("#doConfirm").off("click").on("click", function () {
            if ($(this).attr('disabled') == 'disabled') return;
            if (!(utility.timesale_valid())) return;
            page.showConfirmScreen();
        });
    },
    // お届け先の方へのメッセージ（商品選択画面）
    sendToMessageEvent: function () {
        var MAX_LEN = 128;
        $("#sendToMessage").off("keyup input").on("keyup input", function () {
            var maxLenStr = $(this).val().substr(0, MAX_LEN);
            $(this).val(maxLenStr);
        });
        $("#sendToMessage").off("keydown").on("keydown", function () {
            var e = window.event;
            if (e.keyCode == 13) {
                var strLen = $(this).val().length;
                if (strLen >= MAX_LEN) {
                    e.preventDefault();
                }
            }
        });
    },
    // 戻るボタン（内容確認画面）
    backToSelectProduct: function () {
        $("#backToSelect").on("click", function () {
            if (!(utility.timesale_valid())) return;
            page.backToSelectScreen();
        });
    },
    // お支払いボタン（内容確認画面）
    goToPaymentEvent: function () {
        $("#toSbps").on("click", function () {
            if (!(utility.timesale_valid())) return;

            var casisCommand = utility.getEnviromentInfo(casisMock, environment_id);
            if (casisCommand) {
                setTimeout(casisCommand, 0);
            }

            //page.goToPaymentScreen();
        });
    }
}